import { useEffect, useState, useCallback } from "react";
import * as cuentasApi from "../api/cuentas";

/**
 * Carga las cuentas bancarias del usuario autenticado (Cliente) y mantiene
 * seleccionada una "cuenta activa" para las pantallas de Ingresos/Gastos.
 */
export default function useCuentasCliente() {
  const [cuentas, setCuentas] = useState([]);
  const [cuentaId, setCuentaId] = useState(null);
  const [cargando, setCargando] = useState(true);

  /** Recarga las cuentas (para reflejar saldos actualizados). Por defecto, muestra el spinner de
   * carga; pasa `false` para una recarga silenciosa (ej. tras un alta rápida) que no lo hace.
   * La cuenta seleccionada se conserva siempre -- solo se elige una por defecto si no había ninguna.
   * El backend ya devuelve las cuentas en el orden correcto (principal primero, luego por tipo y
   * Orden manual), así que no hace falta reordenar acá -- es la única fuente de verdad del orden. */
  const recargar = useCallback(async (mostrarCargando = true) => {
    if (mostrarCargando) setCargando(true);
    try {
      const data = await cuentasApi.listarCuentas();
      setCuentas(data);
      setCuentaId((actual) => actual ?? data.find((c) => c.esPrincipal)?.cuentaId ?? data[0]?.cuentaId ?? null);
    } finally {
      if (mostrarCargando) setCargando(false);
    }
  }, []);

  useEffect(() => {
    recargar();
  }, [recargar]);

  return { cuentas, cuentaId, setCuentaId, cargando, recargar };
}
